import { Box, Chip, Divider, Paper, Typography, alpha, useTheme } from "@mui/material";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import { ArtButton } from "@art/shared-ui";
import { getCategoryIcon, formatFeatureCode } from "../../utils/addon-utils";



function ActiveAddons({ addon, handleConfirmCancelAddon }: { addon: any, handleConfirmCancelAddon: (addon: any) => void }) {
    const theme = useTheme();
    const featureCode = formatFeatureCode(addon.addon?.feature?.code);
    return (
        <Paper
            variant="outlined"
            sx={{
                p: 2.5,
                height: "100%",
                position: "relative",
                overflow: "hidden",
                borderLeft: `4px solid ${theme.palette.success.main}`,
                transition: "box-shadow 0.2s ease",
                "&:hover": {
                    boxShadow: `0 2px 12px ${alpha(
                        theme.palette.success.main,
                        0.15
                    )}`,
                },
            }}
        >
            <Box
                display="flex"
                justifyContent="space-between"
                alignItems="flex-start"
                mb={1}
                flexWrap="wrap"
            >
                <Box display="flex" alignItems="center" gap={1}>
                    <Box
                        sx={{
                            width: 36,
                            height: 36,
                            borderRadius: 1.5,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            bgcolor: alpha(theme.palette.success.main, 0.1),
                            color: "success.main",
                            "& .MuiSvgIcon-root": { fontSize: 20 },
                        }}
                    >
                        {getCategoryIcon(
                            addon.addon?.feature?.code || ""
                        )}
                    </Box>
                    <Typography variant="subtitle1" fontWeight={600} sx={{ wordBreak: "break-word" }}>
                        {addon.addon?.name.toUpperCase() || "Add-on"}
                    </Typography>
                </Box>
                <Chip
                    size="small"
                    label={addon.status}
                    color= {addon.status === "active" ? "success" : "warning"}
                    variant="outlined"
                    sx={{
                        height: 22,
                        fontSize: "0.7rem",
                        fontWeight: 600,
                        mt: { xs: 1, sm: 0 }
                    }}
                />
            </Box>

            <Typography
                variant="body2"
                color="text.secondary"
                mb={1.5}
            >
                +{addon.limit_grant * addon.quantity}{" "}
                {featureCode.toLowerCase()} (Qty: {addon.quantity}
                )
            </Typography>

            <Divider />

            <Box
                display="flex"
                justifyContent="space-between"
                alignItems={{ xs: "flex-start", sm: "center" }}
                flexDirection={{ xs: "column", sm: "row" }}
                mt={1.5}
            >
                <Box display="flex" alignItems="center" gap={0.5}>
                    <AutorenewIcon
                        sx={{
                            fontSize: 14,
                            color: addon.auto_renew
                                ? "success.main"
                                : "text.disabled",
                            flexShrink: 0
                        }}
                    />
                    <Typography variant="caption" color="text.secondary">
                        {addon.auto_renew
                            ? "Auto-renew On"
                            : "Auto-renew Off"}
                    </Typography>
                </Box>
                <Typography variant="caption" color="text.secondary">
                    Valid until:{" "}
                    {new Date(addon.valid_until).toLocaleDateString()}
                </Typography>
            </Box>

            {addon.status === "active" && (
                <Box display="flex" justifyContent="flex-end" mt={1.5}>
                    <ArtButton
                        variant="outlined"
                        color="error"
                        label="Cancel"
                        size="small"
                        onClick={() => handleConfirmCancelAddon(addon)}
                    />
                </Box>
            )}
        </Paper>
    )
}

export default ActiveAddons